
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination-offers/[[...page]]",
      function () {
        return require("private-next-pages/destination-offers/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination-offers/[[...page]]"])
      });
    }
  